module.exports = __webpack_public_path__ + "img/1.688b0e94.jpg";